import { defineTokens } from '@chakra-ui/react';

import { aiGradient, partialPrimaryGradient } from '../primitives/colors';

export const GRADIENTS = defineTokens({
  gradients: {
    primary: { value: partialPrimaryGradient },
    ai: { value: aiGradient },
  },
});
